import { Typography } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import {
  PARTNER_DOCUMENTS_TYPE_ABSENCE_OF_CONVICTION_CERTIFICATE,
  PARTNER_DOCUMENTS_TYPE_ANTI_MAFIA_CERTIFICATE,
  PARTNER_DOCUMENTS_TYPE_BALANCE_SHEET,
  PARTNER_DOCUMENTS_TYPE_CHAMBER_OF_COMMERCE_CERTIFICATE,
  PARTNER_DOCUMENTS_TYPE_DURC,
  PARTNER_DOCUMENTS_TYPE_DURF,
  PARTNER_DOCUMENTS_TYPE_HEALT_CARD,
  PARTNER_DOCUMENTS_TYPE_IDENTITY,
  PARTNER_DOCUMENTS_TYPE_MANDATE_CONTRACT,
  PARTNER_DOCUMENTS_TYPE_VEHICLE_INSURANCE_POLICY,
  USER_DOCUMENTS_TYPE_OTHER_DOCUMENTS,
  USER_DOCUMENTS_TYPE_PASSPORT,
} from './usePartnerDocuments'

export const createMappedActions = (t) => ({
  [PARTNER_DOCUMENTS_TYPE_MANDATE_CONTRACT]: {
    getHeader: (item) => {
      return item ? (
        <Typography>
          {t(
            `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_MANDATE_CONTRACT}.uploadDialog.description`
          )}
        </Typography>
      ) : (
        false
      )
    },
    document1: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_MANDATE_CONTRACT}.document1.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_MANDATE_CONTRACT}.document1.loadLabel`
      ),
      getProps: () => {
        return {
          // eslint-disable-next-line sonarjs/no-duplicate-string
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
  },
  [PARTNER_DOCUMENTS_TYPE_IDENTITY]: {
    getHeader: (item) => {
      return item ? (
        <Typography>
          {t(
            `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_IDENTITY}.uploadDialog.description`
          )}
        </Typography>
      ) : (
        false
      )
    },
    // eslint-disable-next-line sonarjs/no-identical-functions
    validate: (item, values) => {
      if (!values.document1 && !values.document2)
        // eslint-disable-next-line sonarjs/no-duplicate-string
        return t('partnerDocuments.uploadDialog.validation.atLeastOneFile')
    },
    document1: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_IDENTITY}.document1.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_IDENTITY}.document1.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          // eslint-disable-next-line sonarjs/no-duplicate-string
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
    document2: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_IDENTITY}.document2.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_IDENTITY}.document2.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
  },
  [PARTNER_DOCUMENTS_TYPE_HEALT_CARD]: {
    getHeader: (item) => {
      return item ? (
        <Typography>
          {t(
            `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_HEALT_CARD}.uploadDialog.description`
          )}
        </Typography>
      ) : (
        false
      )
    },
    validate: (item, values) => {
      if (!values.document1 && !values.document2)
        return t('partnerDocuments.uploadDialog.validation.atLeastOneFile')
    },
    document1: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_HEALT_CARD}.document1.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_HEALT_CARD}.document1.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
    document2: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_HEALT_CARD}.document2.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_HEALT_CARD}.document2.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
  },
  [PARTNER_DOCUMENTS_TYPE_CHAMBER_OF_COMMERCE_CERTIFICATE]: {
    getHeader: (item) => {
      return item ? (
        <Typography>
          {t(
            `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_CHAMBER_OF_COMMERCE_CERTIFICATE}.uploadDialog.description`
          )}
        </Typography>
      ) : (
        false
      )
    },
    document1: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_CHAMBER_OF_COMMERCE_CERTIFICATE}.document1.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_CHAMBER_OF_COMMERCE_CERTIFICATE}.document1.loadLabel`
      ),
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
  },
  [PARTNER_DOCUMENTS_TYPE_DURC]: {
    getHeader: (item) => {
      return item ? (
        <Typography>
          {t(
            `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_DURC}.uploadDialog.description`
          )}
        </Typography>
      ) : (
        false
      )
    },
    document1: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_DURC}.document1.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_DURC}.document1.loadLabel`
      ),
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
  },
  [PARTNER_DOCUMENTS_TYPE_DURF]: {
    getHeader: (item) => {
      return item ? (
        <Typography>
          {t(
            `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_DURF}.uploadDialog.description`
          )}
        </Typography>
      ) : (
        false
      )
    },
    document1: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_DURF}.document1.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_DURF}.document1.loadLabel`
      ),
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
  },
  [PARTNER_DOCUMENTS_TYPE_BALANCE_SHEET]: {
    getHeader: (item) => {
      return item ? (
        <Typography>
          {t(
            `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_BALANCE_SHEET}.uploadDialog.description`
          )}
        </Typography>
      ) : (
        false
      )
    },
    validate: (item, values) => {
      if (!values.document1 && !values.document2 && !values.document3)
        return t('partnerDocuments.uploadDialog.validation.atLeastOneFile')
    },
    document1: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_BALANCE_SHEET}.document1.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_BALANCE_SHEET}.document1.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
    document2: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_BALANCE_SHEET}.document2.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_BALANCE_SHEET}.document2.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
    document3: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_BALANCE_SHEET}.document3.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_BALANCE_SHEET}.document3.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
  },
  [PARTNER_DOCUMENTS_TYPE_ANTI_MAFIA_CERTIFICATE]: {
    getHeader: (item) => {
      return item ? (
        <Typography>
          {t(
            `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_ANTI_MAFIA_CERTIFICATE}.uploadDialog.description`
          )}
        </Typography>
      ) : (
        false
      )
    },
    document1: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_ANTI_MAFIA_CERTIFICATE}.document1.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_ANTI_MAFIA_CERTIFICATE}.document1.loadLabel`
      ),
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
  },
  [PARTNER_DOCUMENTS_TYPE_ABSENCE_OF_CONVICTION_CERTIFICATE]: {
    getHeader: (item) => {
      return item ? (
        <Typography>
          {t(
            `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_ABSENCE_OF_CONVICTION_CERTIFICATE}.uploadDialog.description`
          )}
        </Typography>
      ) : (
        false
      )
    },
    document1: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_ABSENCE_OF_CONVICTION_CERTIFICATE}.document1.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_ABSENCE_OF_CONVICTION_CERTIFICATE}.document1.loadLabel`
      ),
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
  },
  [PARTNER_DOCUMENTS_TYPE_VEHICLE_INSURANCE_POLICY]: {
    getHeader: (item) => {
      return item ? (
        <Typography>
          {t(
            `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_VEHICLE_INSURANCE_POLICY}.uploadDialog.description`
          )}
        </Typography>
      ) : (
        false
      )
    },
    document1: {
      label: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_VEHICLE_INSURANCE_POLICY}.document1.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${PARTNER_DOCUMENTS_TYPE_VEHICLE_INSURANCE_POLICY}.document1.loadLabel`
      ),
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
  },
  [USER_DOCUMENTS_TYPE_OTHER_DOCUMENTS]: {
    getHeader: (item) => {
      return item ? (
        <Typography>
          {t(
            `partnerDocuments.types.${USER_DOCUMENTS_TYPE_OTHER_DOCUMENTS}.uploadDialog.description`
          )}
        </Typography>
      ) : (
        false
      )
    },
    validate: (item, values) => {
      if (!values.document1 && !values.document2 && !values.document3)
        return t('partnerDocuments.uploadDialog.validation.atLeastOneFile')
    },
    document1: {
      label: t(
        `partnerDocuments.types.${USER_DOCUMENTS_TYPE_OTHER_DOCUMENTS}.document1.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${USER_DOCUMENTS_TYPE_OTHER_DOCUMENTS}.document1.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
    document2: {
      label: t(
        `partnerDocuments.types.${USER_DOCUMENTS_TYPE_OTHER_DOCUMENTS}.document2.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${USER_DOCUMENTS_TYPE_OTHER_DOCUMENTS}.document2.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
    document3: {
      label: t(
        `partnerDocuments.types.${USER_DOCUMENTS_TYPE_OTHER_DOCUMENTS}.document3.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${USER_DOCUMENTS_TYPE_OTHER_DOCUMENTS}.document3.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
  },
  [USER_DOCUMENTS_TYPE_PASSPORT]: {
    getHeader: (item) => {
      return item ? (
        <Typography>
          {t(
            `partnerDocuments.types.${USER_DOCUMENTS_TYPE_PASSPORT}.uploadDialog.description`
          )}
        </Typography>
      ) : (
        false
      )
    },
    // eslint-disable-next-line sonarjs/no-identical-functions
    validate: (item, values) => {
      if (!values.document1 && !values.document2 && !values.document3)
        // eslint-disable-next-line sonarjs/no-duplicate-string
        return t('partnerDocuments.uploadDialog.validation.atLeastOneFile')
    },
    document1: {
      label: t(
        `partnerDocuments.types.${USER_DOCUMENTS_TYPE_PASSPORT}.document1.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${USER_DOCUMENTS_TYPE_PASSPORT}.document1.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
    document2: {
      label: t(
        `partnerDocuments.types.${USER_DOCUMENTS_TYPE_PASSPORT}.document2.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${USER_DOCUMENTS_TYPE_PASSPORT}.document2.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
    document3: {
      label: t(
        `partnerDocuments.types.${USER_DOCUMENTS_TYPE_PASSPORT}.document3.label`
      ),
      loadLabel: t(
        `partnerDocuments.types.${USER_DOCUMENTS_TYPE_PASSPORT}.document3.loadLabel`
      ),
      optional: true,
      // eslint-disable-next-line sonarjs/no-identical-functions
      getProps: () => {
        return {
          accept: '.pdf, .jpg, .jpeg',
        }
      },
    },
  },
})

export const useMapPartnerDocumentsActions = () => {
  const { t } = useTranslation()

  const mappedActions = useMemo(() => {
    return createMappedActions(t)
  }, [t])

  return {
    mappedActions,
  }
}
